document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initHeroRotation();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initHeroRotation() {
  var poolEl = document.querySelector('[data-mt-hero-pool]');
  var items = document.querySelectorAll('.mt-hero__grid-item');
  if (!poolEl || !items.length) return;

  var pool;
  try {
    pool = JSON.parse(poolEl.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(pool) || pool.length < items.length) return;

  var STORAGE_KEY = 'mt_hero_session_products';
  var handles = null;
  try {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    handles = saved ? JSON.parse(saved) : null;
  } catch (e) {
    handles = null;
  }

  var valid = Array.isArray(handles) && handles.length === items.length &&
    handles.every(function (h) { return pool.some(function (p) { return p.handle === h; }); });

  if (!valid) {
    var shuffled = pool.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = tmp;
    }
    handles = shuffled.slice(0, items.length).map(function (p) { return p.handle; });
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* sessionStorage no disponible, se repetirá el sorteo en cada carga */
    }
  }

  items.forEach(function (item, idx) {
    var data = pool.filter(function (p) { return p.handle === handles[idx]; })[0];
    if (!data) return;
    var img = item.querySelector('img');
    var link = item.querySelector('a');
    if (img && data.image) {
      img.style.transition = 'opacity 0.25s ease';
      img.style.opacity = '0';
      var preload = new Image();
      preload.onload = function () {
        img.src = data.image;
        img.alt = data.title || '';
        img.style.opacity = '1';
      };
      preload.src = data.image;
    }
    if (link) {
      link.href = data.url;
      link.setAttribute('aria-label', data.title || '');
    }
  });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString();
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}
